// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1e0c1txw{display:flex}
._1tket9kd{min-height:72px}
._4cvr1q9y{align-items:baseline}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/dist/esm/ui/confluence-search-modal/modal/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,YAAY;AACvB,WAAW,eAAe;AAC1B,WAAW,oBAAoB","sourcesContent":["._1e0c1txw{display:flex}\n._1tket9kd{min-height:72px}\n._4cvr1q9y{align-items:baseline}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
